import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";
import { da } from "date-fns/locale";

class InsumosStoreDB extends FirestorePipe {
    public static readonly colName = 'Insumos'

    constructor(idEstab: string, idStore: string) {
        if (!idEstab)
            throw new Error('Informe o id do estabelecimento')
        if (!idStore)
            throw new Error('Informe o id do store')
        super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${InsumosStoreDB.colName}`);
    }

    public async define(id: string, data: any): Promise<any> {
        return this._define(id, data);
    }

    public async create(data: any): Promise<any> {
        return this._create(data)
    }
    public async update(id: string, data: any): Promise<any> {
        return this._update(id, data);
    }
    public delete(id: string): Promise<any> {
        throw new Error('Method not exists')
    }
    public getAll(...params: QueryConstraint[]): Promise<any[]> {
        return this._getAll<any>(...params);
    }
    public get(id: string): Promise<any> {
        return this._get(id);
    }
    public on(listener: (data: any[]) => void, ...params: QueryConstraint[]): Unsubscribe {
        return this._on(listener, ...params);
    }




}

export default InsumosStoreDB;